import React from 'react';
import { OrganizationConfigPage } from './OrganizationConfigPage';
import { DepartmentsPage } from './DepartmentsPage';
import { CategoriesPage } from './CategoriesPage';
import { PrioritiesPage } from './PrioritiesPage';
import { StatusesPage } from './StatusesPage';
import { CustomFieldsPage } from './CustomFieldsPage';
import { SLAConfigPage } from './SLAConfigPage';
import { NumberPatternsPage } from './NumberPatternsPage';
import { RolesPermissionsPage } from './RolesPermissionsPage';
import { SystemSettingsPage } from './SystemSettingsPage';
import { AuditLogsPage } from './AuditLogsPage';
import { SecuritySettingsPage } from './SecuritySettingsPage';
import { LoginHistoryPage } from './LoginHistoryPage';
import { UsersPage } from './UsersPage';
import { useNavigation } from '../../context/NavigationContext';
import { Settings } from 'lucide-react';

export const AdminConfigPage: React.FC = () => {
  const { activeAdminSection } = useNavigation();

  const renderSection = () => {
    switch (activeAdminSection) {
      case 'organization': return <OrganizationConfigPage />;
      case 'departments': return <DepartmentsPage />;
      case 'categories': return <CategoriesPage />;
      case 'subcategories': return <CategoriesPage />;
      case 'priorities': return <PrioritiesPage />;
      case 'statuses': return <StatusesPage />;
      case 'sla-rules': return <SLAConfigPage />;
      case 'notification-rules': return <SLAConfigPage />;
      case 'custom-fields': return <CustomFieldsPage />;
      case 'number-patterns': return <NumberPatternsPage />;
      case 'users': return <UsersPage />;
      case 'roles-permissions': return <RolesPermissionsPage />;
      case 'general-settings': return <SystemSettingsPage />;
      case 'audit-logs': return <AuditLogsPage />;
      case 'security-settings': return <SecuritySettingsPage />;
      case 'login-history': return <LoginHistoryPage />;
      default: return <OrganizationConfigPage />;
    }
  };

  return (
    <div className="space-y-5">
      <div className="flex items-center gap-3">
        <div className="p-2 bg-sky-500/10 rounded-xl">
          <Settings className="w-5 h-5 text-sky-400" />
        </div>
        <div>
          <h2 className="text-xl font-semibold text-slate-100">System Configuration</h2>
          <p className="text-xs text-slate-400">Admin-only portal for dynamic application parameter management</p>
        </div>
      </div>

      <div className="min-h-[500px]">
        {renderSection()}
      </div>
    </div>
  );
};
